import { render } from "./RejectedOvertime.vue?vue&type=template&id=4933beb8&scoped=true"
import script from "./RejectedOvertime.vue?vue&type=script&lang=js"
export * from "./RejectedOvertime.vue?vue&type=script&lang=js"

import "./RejectedOvertime.vue?vue&type=style&index=0&id=4933beb8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4933beb8"]])

export default __exports__